/// <reference types="@angular/localize" />

/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
import { enableProdMode, StaticProvider } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { BASE_URL } from '@cer/cer-session/cer-session-environment.service';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers : StaticProvider[] = [
  { provide: BASE_URL, useFactory: getBaseUrl }
];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));
